
/**
 * 工作流-参数提取节点
 * zxw
 * 创建时间 2026-05-07
 */

import CNF from '../../incs/Config';
import { winHeight, } from '../../incs/FunHelper';
import { convertVariableTags, formattedContent } from '../../components/MultifunctionalInput';
import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Avatar,
    Space,
    Divider,
    Input,
    Select,
    Button,
    Typography,
    Row,
    Col,
    Tag,
    Tooltip,
    Popover,
} from 'antd';
import {
    CheckOutlined,
    EditOutlined,
    PlusOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    RightOutlined,
} from '@ant-design/icons';
import ContentEditable from "react-contenteditable";

const { Text, Paragraph } = Typography;

const ParamexNodeEntity = (props) => {
    const [open, setOpen] = useState(false);
    const [isEditTitle, setIsEditTitle] = useState(false);  // 标题是否编辑
    const [currentTitle, setCurrentTitle] = useState('');   // 当前标题

    const [model, setModel] = useState('');
    const [params, setParams] = useState([]);       // 请求参数

    const [userPromptIsFocused, setUserPromptIsFocused] = useState(false);           // 用户提示词是否聚焦
    const [userPrompt, setUserPrompt] = useState('');                                // 用户提示词
    const [openUserPromptVariable, setOpenUserPromptVariable] = useState(false);     // 开启用户提示词变量

    const cancel = () => {
        setOpen(false);
        setIsEditTitle(false);
    }

    useEffect(() => {
        setOpen(props.open);

        setCurrentTitle(props.node.data?.title);

        // 初始化
        setModel(props.node.data?.model?.label);
        setParams((props.node?.data?.input?.params) ? props.node?.data?.input?.params : []);
        if (props.node.data?.input.user_prompt) {
            setUserPrompt(props.node.data.input.user_prompt);      // 初始化用户提示词
        } else {
            setUserPrompt('');
        }

    }, [props]);

    useEffect(() => {
        let systemPrompt = `# 角色
你是一个参数提取助手，请从用户的输入中提取相应的参数。

# 提取要求`;

        let output = {};
        let outputFormat = `{`;
        for (let i = 0; i < params.length; i++) {
            let item = params[i];
            if (item.name) {
                // 系统提示词
                systemPrompt += `
- ${item.name}：${item.description}，类型为 ${item.type}。`;

                // 输出格式
                outputFormat += `
    "${item.name}": "xxx",`;

                // 输出，
                output[item.name] = '';
            }
        }
        outputFormat += `
}`;

        systemPrompt += `

# 处理规则
## 通用处理规则
- 如果用户的输入中没有对应的值，则 string、number 类型的参数填写为空字符串，array 类型的参数填写为 []。

## 日期处理规则
- 将输入的日期格式统一为 yyyy-mm-dd。
- 如果用户输入的是年，比如2026年，则开始时间设置为2026-01-01，结束时间为2026-12-31。

# 输出
请以JSON格式按以下要求返回：
${outputFormat}`;

        // 更新系统提示词和输出
        props.node.setData({
            ...(delete props.node.data?.output, props.node.data),
            input: {
                system_prompt: systemPrompt,
            },
            output: output,
        });
    }, [params]);


    useEffect(() => {
        // 更新用户提示词
        props.node.setData({
            ...props.node.data,
            input: {
                user_prompt: convertVariableTags(userPrompt),
            },
        });
    }, [userPrompt]);


    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            <Modal
                title={
                    <Space>
                        <Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />
                        {
                            isEditTitle ? <Input
                                value={currentTitle}
                                onChange={(e) => {
                                    setCurrentTitle(e.target.value);
                                }}
                            /> : props.node.data?.title
                        }
                        {
                            isEditTitle ?
                                <Button color='primary' variant='link' icon={<CheckOutlined />} onClick={() => {
                                    props.node.setData({
                                        ...props.node.data,
                                        title: currentTitle,
                                    });
                                    setIsEditTitle(false);
                                }} />
                                :
                                <Button color='primary' variant='link' icon={<EditOutlined />} onClick={() => {
                                    setIsEditTitle(true);
                                }} />
                        }
                    </Space>
                }
                width={480}
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                }}
                mask={{
                    enabled: false,
                    closable: true,
                }}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Space><Text>模型配置</Text><Text type='danger'>*</Text></Space>
                    <Select
                        placeholder='请选择模型'
                        style={{ width: '100%' }}
                        options={CNF.models.map(item => {
                            return {
                                label: <Space><Avatar size='small' src={item.logo} />{item.label}</Space>,
                                title: item.label,
                                options: item.versions,
                            }
                        })}
                        value={model ? model : undefined}
                        onChange={(value, options) => {
                            // 模型名称
                            const name = CNF.models.find(m => m.versions.some(v => v.value === options.value))?.name;
                            setModel(value);
                            props.node.setData({
                                ...props.node.data,
                                model: {
                                    ...options,
                                    name: name,
                                },
                            });
                        }}
                    />
                </Paragraph>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph><Space>提取参数<Tooltip title='模型将根据名称、类型和描述从输入中提取参数'><InfoCircleOutlined style={{ color: props.colorBasePlaceholder }} /></Tooltip></Space></Paragraph>
                <Row>
                    <Col span={6}>变量名</Col>
                    <Col span={5}>变量类型</Col>
                    <Col span={13}>描述</Col>
                </Row>
                {
                    params && params.map((item, index) => {
                        // 通用更新函数：更新指定索引的字段
                        const updateParam = (field, value) => {
                            const newParams = params.map((p, i) =>
                                i === index ? { ...p, [field]: value } : p
                            );
                            setParams(newParams);
                            props.node.setData({
                                ...props.node.data,
                                input: {
                                    params: newParams,
                                },
                            });
                        };

                        return <Row key={index} style={{ marginTop: 5, }}>
                            <Col span={6} style={{ paddingRight: 8, }}>
                                <Input
                                    placeholder='请输入名称'
                                    size='small'
                                    value={item.name}
                                    onChange={(e) => updateParam('name', e.target.value)}
                                />
                            </Col>
                            <Col span={5} style={{ paddingRight: 8, }}>
                                <Select
                                    placeholder='请选择类型'
                                    style={{ width: '100%' }}
                                    size='small'
                                    options={CNF.variableTypes.map(item => {
                                        return {
                                            label: item,
                                            value: item,
                                        }
                                    })}
                                    value={item.type}
                                    onChange={(value) => updateParam('type', value)}
                                />
                            </Col>
                            <Col span={12}>
                                <Input
                                    placeholder='请输入描述'
                                    size='small'
                                    value={item.description}
                                    onChange={(e) => updateParam('description', e.target.value)}
                                />
                            </Col>
                            <Col span={1}>
                                <Button
                                    size='small'
                                    color='primary'
                                    variant='link'
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        setParams(prev => prev.filter((_, i) => i !== index));
                                    }}
                                />
                            </Col>
                        </Row>
                    })
                }

                <Button size='small' color='primary' variant='link' icon={<PlusOutlined />} style={{ padding: 0, fontSize: props.fontSizeSM }} onClick={() => {
                    setParams([...params, {
                        name: '',
                        type: CNF.variableTypes[0],
                        description: '',
                    }]);
                }}>添加参数</Button>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>提示词</Paragraph>
                <div style={{
                    position: 'relative',
                    border: `1px solid ${userPromptIsFocused ? props.colorPrimary : '#d9d9d9'}`,
                    padding: '10px 10px 2px 10px',
                    borderRadius: 6,
                    transition: 'all 0.2s',
                    boxShadow: `0 0 0 ${userPromptIsFocused ? '1.5px' : '0'} ${props.colorPrimaryBg}`,
                }}>
                    <div
                        style={{
                            height: 60,
                            scrollbarColor: '#d9d9d9 transparent',
                            scrollbarWidth: 'thin',
                            overflowY: 'auto',
                        }}
                        onFocus={() => setUserPromptIsFocused(true)}
                        onBlur={() => {
                            setUserPromptIsFocused(false);
                        }}
                    >
                        <ContentEditable
                            html={formattedContent(userPrompt, props.graph)}  // 渲染带格式的 HTML
                            onChange={(e) => {
                                setUserPrompt(e.target.value ? e.target.value : '');
                            }}
                            tagName='div'
                            style={{ minHeight: '40px', outline: 'none' }}
                            onKeyDown={(e) => {
                                // 只处理单字符按键（key 长度为 1 且不是修饰键）
                                if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
                                    // 注意：e.key 已经考虑了 Shift，例如 Shift+a 得到 'A'
                                    // 输入“/或者、”弹出变量选项界面
                                    if (e.key === '/' || e.key === '、') {
                                        e.preventDefault();
                                        setOpenUserPromptVariable(true);
                                    } else {
                                        setOpenUserPromptVariable(false);
                                    }
                                }
                            }}
                        />
                        <style>{`
                            .variable-tag {
                                background: #F5F6F8;
                                border-radius: 4px;
                                padding: 2px 6px;
                                margin: 0 4px;
                                color: ${props.colorTextBase};
                                user-select: all;
                                cursor: default;
                                font-size: ${CNF.fontSizeSM}px;
                            }
                            .variable-name {
                                color: ${props.colorPrimary};
                            }
                        `}</style>
                    </div>
                    <Text style={{ fontSize: CNF.fontSizeXS, color: CNF.basePlaceholderColor }}>输入“/”插入变量</Text>
                    {
                        openUserPromptVariable ? <div style={{
                            position: 'absolute',
                            top: 40,
                            left: 18,
                            width: 200,
                            padding: '6px 8px',
                            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #00000033',
                            borderRadius: 6,
                            background: '#fff',
                            fontSize: CNF.fontSizeSM,
                        }}>
                            <Space orientation='vertical' style={{ display: 'flex', }}>
                                {
                                    props.graph && props.graph.getNodes().map(node => {
                                        if (node.data?.key === 'End' || node.getZIndex() >= props.node.getZIndex()) return;
                                        return <Popover
                                            key={node.id}
                                            placement='leftTop'
                                            arrow={false}
                                            title={null}
                                            align={{
                                                offset: [-12, 0],
                                            }}
                                            styles={{
                                                container: {
                                                    padding: '4px 6px',
                                                },
                                            }}
                                            content={<Space orientation='vertical' style={{ display: 'flex' }}>
                                                {
                                                    Object.keys(node.data?.key === 'Start' ? node.data?.input.sys : node.data?.output).map((item, index) => {
                                                        return <Button key={index} color='default' variant='text' style={{ width: '100%', justifyContent: 'left' }} onClick={(e) => {
                                                            const path = node.getZIndex().toString() + (node.data?.key === 'Start' ? '/input/sys/' : '/output/') + item;
                                                            setUserPrompt((userPrompt ? userPrompt : '') + CNF.APP_CONFIG_SPLIT + path + CNF.APP_CONFIG_SPLIT);
                                                            setOpenUserPromptVariable(false);
                                                        }}><Space><Text>{item}</Text><Tag>string</Tag></Space></Button>
                                                    })
                                                }
                                            </Space>}
                                        >
                                            <Space>
                                                <Avatar size={20} shape='square' icon={node.data.icon} style={{ background: node.data.theme, }} />
                                                <Text ellipsis style={{ width: 152 }}>{node.data.title}</Text>
                                                <RightOutlined />
                                            </Space>
                                        </Popover>
                                    })
                                }
                            </Space>
                        </div> : ''
                    }
                </div>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>输出</Paragraph>
                {
                    params && params.map((item, index) => {
                        return <Paragraph key={index}><Space><Text>{item.name}</Text><Tag size='small' style={{ color: props.colorBasePlaceholder }}>{item.type}</Tag></Space></Paragraph>
                    })
                }
            </Modal>
        </ConfigProvider >
    );
}

export default ParamexNodeEntity;